import apiFetch from '../apiFetch'

export default function (token, customFieldId) {
  return apiFetch({ endPoint: `Masters/CustomField/${customFieldId}`, method: 'DELETE', body: null, token: token })
}
